import React, { forwardRef, useEffect, useRef, useState } from 'react';
import { Select } from 'antd';
import { RefSelectProps, SelectProps } from 'antd/es/select';
import { groupBy } from 'lodash';

import { gameConfigService } from '@lib/services/game-config';
import { GameConfig } from '@lib/services/models';

export type ClientVersionSelectProps = SelectProps<string> & {
  environment?: string;
};

const ClientVersionSelect = forwardRef<RefSelectProps, ClientVersionSelectProps>((props, ref) => {
  const { environment, value, onChange, ...selectProps } = props;

  const [selectedId, setSelectedId] = useState<number>();

  const gameConfigRef = useRef<GameConfig[]>([]);
  const [gameConfigs, setGameConfigs] = useState<Record<string, GameConfig[]>>({});
  const [filteredGameConfig, setFilteredGameConfigs] = useState<Record<string, GameConfig[]>>({});

  const filterGameConfig = () => {
    const data = environment
      ? {
          [environment]: gameConfigs[environment] ?? [],
        }
      : gameConfigs;
    setFilteredGameConfigs(data);
  };

  const loadClientVersions = async () => {
    const res = await gameConfigService.getAll();
    if (res.ok) {
      gameConfigRef.current = res.data ?? [];
      setGameConfigs(groupBy(gameConfigRef.current, 'environment'));
    }
  };

  const handleChange = (val: number, option: any) => {
    if (typeof onChange === 'function') {
      const gameConfig = gameConfigRef.current.find((item) => item.id === val);
      onChange(gameConfig?.clientVersion as any, option);
    }
  };

  useEffect(() => {
    loadClientVersions();
  }, []);

  useEffect(() => {
    const gameConfig = gameConfigRef.current.find((item) => item.clientVersion === value);
    setSelectedId(gameConfig?.id);
  }, [value, gameConfigs]);

  useEffect(() => {
    filterGameConfig();
  }, [gameConfigs, environment]);

  return (
    <Select<number>
      placeholder="Select client version"
      {...(selectProps as any)}
      value={selectedId}
      onChange={handleChange}
      showSearch
      ref={ref}
    >
      {Object.keys(filteredGameConfig).map((env) => (
        <Select.OptGroup key={env} label={env.toUpperCase()}>
          {filteredGameConfig[env].map((item) => (
            <Select.Option key={item.id} value={item.id ?? 0}>
              {item.clientVersion} (Blueprint {item.blueprintVersion})
            </Select.Option>
          ))}
        </Select.OptGroup>
      ))}
    </Select>
  );
});

export default ClientVersionSelect;
